module.exports = __webpack_public_path__ + "img/user_bw.2aa71531.svg";